import React,{useEffect} from 'react';

const GostoryPlayer=()=> {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "/cw/load-widget.js";
        script.setAttribute('init',"pxft-main");
        script.setAttribute('pixId',"14x38");
        script.async = true;
        const elem = document.getElementById('gostory-player');
        elem.appendChild(script);
        return () => {
            elem.removeChild(script);
        }
    }, []);
    return (
        <div id='gostory-player' className=''></div>
    );
}

export default GostoryPlayer;